import { unwrapResult } from '@reduxjs/toolkit';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Text, Button, Modal } from '@rsos/components/capstone/base';
import {
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@rsos/components/capstone/base/Modal/ModalComponents';
import {
  removeAgency,
  removeAgencyLinks,
} from '@rsos/reduxDataStore/src/features/alertsRouting/alertsRoutingSlice';
import { notifyError } from '@rsos/utils/toastUtils';

const RemovePairModal = ({ isOpened, authority, onClose, type }) => {
  const dispatch = useDispatch();
  const { sinatra } = useSelector(state => state);
  const org = sinatra.user.currentOrg.name;
  const { id } = authority;
  const data = {
    org,
    id,
  };
  const handleDelete = () => {
    dispatch(removeAgency(data))
      .then(unwrapResult)
      .then(() => {
        dispatch(removeAgencyLinks({ id, type }));
        onClose();
      })
      .catch(error => {
        notifyError(error);
      });
  };

  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      width={400}
      id="modal-remove-agency-pair"
    >
      <>
        <ModalHeader onClose={onClose}>
          <Box width={400}>
            <Text size="xlarge" fontWeight="semibold" color="primaryText">
              Remove agency
            </Text>
          </Box>
        </ModalHeader>
        <ModalBody>
          <Text size="normal" color="secondaryLink">
            Are you sure you want to remove this agency? You will no longer be
            able to receive their alerts. You cannot undo this action.
          </Text>
        </ModalBody>
        <ModalFooter flow={12}>
          <Button btnType="tertiary" onClick={onClose} grow noMargin>
            Cancel
          </Button>
          <Button
            btnType="warning_primary"
            onClick={handleDelete}
            grow
            noMargin
          >
            Remove
          </Button>
        </ModalFooter>
      </>
    </Modal>
  );
};

export default RemovePairModal;
